import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  deleteSinglePendingArtisanSuccessAction,
  getPendingArtisansSuccessAction,
  getSinglePendingArtisanSuccessAction,
  moderateCreateSinglePendingArtisanSuccessAction,
  setPendingArtisansCountAction,
  setPendingArtisansIsLoadingAction,
  updatePendingArtisanSuccessAction,
} from './Actions';
import { push } from 'react-router-redux';

import { authUserIdSelector } from '../../auth/Selectors';
import { actions } from './Reducer';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';

import * as api from './Api';
import { func } from 'prop-types';

function* getPendingArtisans({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [],
    filterCountry: '',
    sort: 'createdAt',
    dir: 'asc',
  };
  // "offset": 0,
  // "size": 10,
  // "searchTerm": "",
  // "filterBy": [],
  // "filterCountry": "",
  // "sort": "",
  // "dir": "asc"

  const body = { ...defData, ...payload };
  try {
    yield put(setPendingArtisansIsLoadingAction(true));
    const response = yield call(api.getPendingArtisans, body);
    const { data } = response;
    const { count, content } = data;
    console.log(data);
    yield put(getPendingArtisansSuccessAction(content));
    yield put(setPendingArtisansCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisansIsLoadingAction(false));
  }
}

function* updatePendingArtisan({ payload }) {
  const moderatorID = yield select(authUserIdSelector);
  const defData = {
    moderatorID,
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingArtisansIsLoadingAction(true));

    yield call(api.updatePendingArtisan, body);

    yield put(newSuccessNotificationAction('Artisan Moderated'));

    yield put(updatePendingArtisanSuccessAction(body.moderationRecordID));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisansIsLoadingAction(false));
  }
}

function* getSinglePendingArtisan({ payload }) {
  const id = payload;
  try {
    yield put(setPendingArtisansIsLoadingAction(true));

    const response = yield call(api.getSinglePendingArtisan, id);

    const { data } = response;

    yield put(getSinglePendingArtisanSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisansIsLoadingAction(false));
  }
}

function* deleteSinglePendingArtisan({ payload }) {
  const id = payload;
  try {
    yield put(setPendingArtisansIsLoadingAction(true));
    yield call(api.deleteSinglePendingArtisan, id);
    yield put(deleteSinglePendingArtisanSuccessAction(id));
     yield put(newSuccessNotificationAction('Artisan Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisansIsLoadingAction(false));
  }
}

function* moderateCreateSinglePendingArtisan({ payload, mode }) {
  const id = payload;
  try {
    yield put(setPendingArtisansIsLoadingAction(true));
    if (mode === 'update') {
    const response = yield call(api.moderateUpdateSinglePendingArtisan, id);
    const { data } = response;
    yield put(moderateCreateSinglePendingArtisanSuccessAction(id));
    yield put(push('/artisans-moderation/artisans'))
    yield put(newSuccessNotificationAction('Artisan Update Moderated'));
    } else {
          const response = yield call(api.moderateSinglePendingArtisan, id);
    const { data } = response;
    yield put(moderateCreateSinglePendingArtisanSuccessAction(id));
    yield put(push('/artisans-moderation/artisans'))
    yield put(newSuccessNotificationAction('Artisan Moderated'));
    }
    // const response = yield call(api.moderateSinglePendingArtisan, id);
    // const { data } = response;
    // yield put(moderateCreateSinglePendingArtisanSuccessAction(id));
    // yield put(push('/artisans-moderation/artisans'))
    // yield put(newSuccessNotificationAction('Artisan Moderated'));
    
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisansIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_PENDING_ARTISANS, getPendingArtisans);
  yield takeLatest(actions.UPDATE_PENDING_ARTISAN, updatePendingArtisan);
  yield takeLatest(actions.GET_SINGLE_PENDING_ARTISAN, getSinglePendingArtisan);
  yield takeLatest(
    actions.DELETE_SINGLE_PENDING_ARTISAN,
    deleteSinglePendingArtisan
  );
  yield takeLatest(
    actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN,
    moderateCreateSinglePendingArtisan
  );
}
